import * as Yup from "yup";
import * as CONSTANTS from "../../utils/constants";
import { EmailRegex, isValidName } from "../../utils/regex";

export const addUserFormSchema = Yup.object().shape({
  userRole: Yup.string().required(CONSTANTS.ROLE.validation.required),
  firstName: Yup.string().required(CONSTANTS.FIRST_NAME.validation.required),
  //.matches(isValidName, CONSTANTS.FIRST_NAME.validation.valid),
  lastName: Yup.string().required(CONSTANTS.LAST_NAME.validation.required),
  //.matches(isValidName, CONSTANTS.LAST_NAME.validation.valid),
  email: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .matches(EmailRegex, CONSTANTS.EMAIL.validation.valid),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("countryCode", {
      is: (countryCode: any) => countryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
});

export const profileFormSchema = Yup.object().shape({
  firstName: Yup.string().required(CONSTANTS.FIRST_NAME.validation.required),
  //.matches(isValidName, CONSTANTS.FIRST_NAME.validation.valid),
  lastName: Yup.string().required(CONSTANTS.LAST_NAME.validation.required),
  //.matches(isValidName, CONSTANTS.LAST_NAME.validation.valid),
  email: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .email(CONSTANTS.EMAIL.validation.valid),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("countryCode", {
      is: (countryCode: any) => countryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
});

export const changePasswordSchema = Yup.object().shape({
  password: Yup.string().required(CONSTANTS.PASSWORD.validation.required),
  newPassword: Yup.string()
    .required(CONSTANTS.PASSWORD.validation.required)
    .min(8, CONSTANTS.PASSWORD.validation.valid)
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]+$/,
      CONSTANTS.PASSWORD.validation.valid
    ),
  confirmPassword: Yup.string()
    .nullable()
    .required(CONSTANTS.CONFIRM_PASSWORD.validation.required)
    .oneOf(
      [Yup.ref("newPassword")],
      CONSTANTS.CONFIRM_PASSWORD.validation.match
    ),
});

export const addCustomerUserFormSchema = Yup.object().shape({
  //userRole: Yup.string().required(CONSTANTS.ROLE.validation.required),
  firstName: Yup.string().required(CONSTANTS.FIRST_NAME.validation.required),
  lastName: Yup.string().required(CONSTANTS.LAST_NAME.validation.required),
  email: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .matches(EmailRegex, CONSTANTS.EMAIL.validation.valid),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("countryCallingCode", {
      is: (countryCallingCode: any) => countryCallingCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) =>
        s
          .min(10, CONSTANTS.PHONENUMBER.validation.valid)
          .max(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
});

export const addCustomerFormSchema = Yup.object().shape({
  customerName: Yup.string()
    .required(CONSTANTS.CUSTOMERNAME.validation.required)
    .matches(isValidName, CONSTANTS.CUSTOMERNAME.validation.valid),
  emailAddress: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .matches(EmailRegex, CONSTANTS.EMAIL.validation.valid),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("countryCallingCode", {
      is: (countryCallingCode: any) => countryCallingCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
  addressContactName: Yup.string().required(
    CONSTANTS.CONTACT_PERSON.validation.required
  ),
  //phoneExt: Yup.string().required(CONSTANTS.PHONE_EXT.validation.required),
  address: Yup.string().required(CONSTANTS.ADDRESS.validation.valid),
  //aptSuite: Yup.string().required("Please enter APT/Suite name"),
  zipCode: Yup.string()
    .required(CONSTANTS.ZIP_CODE.validation.valid)
    .min(5, CONSTANTS.ZIP_CODE.validation.valid)
    .max(9, CONSTANTS.ZIP_CODE.validation.valid),
  customerPhoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("customerCountryCallingCode", {
      is: (customerCountryCallingCode: any) =>
        customerCountryCallingCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
  //customerPhoneExt: Yup.string().required(CONSTANTS.PHONE_EXT.validation.required),
  businessLocation: Yup.string().required("Please enter business location"),
  firstName: Yup.string().required(CONSTANTS.FIRST_NAME.validation.required),
  lastName: Yup.string().required(CONSTANTS.LAST_NAME.validation.required),
  // contactPerson: Yup.string().required(
  //   CONSTANTS.CONTACT_PERSON.validation.required
  // ),
  contactEmail: Yup.array().min(1, CONSTANTS.EMAIL.validation.required),
  latitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-90, "Min latitude value should be -90")
    .max(90, "Max latitude value should be 90"),
  longitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-180, "Min longitude value should be -180")
    .max(180, "Max longitude value should be 180"),
  worldWideDirectReference: Yup.string().when("worldwideExpress", {
    is: (worldwideExpress: any) => worldwideExpress === true,
    then: (s) => s.required(`Please enter audience`),
  }),
  worldWideDirectUser: Yup.string().when("worldwideExpress", {
    is: (worldwideExpress: any) => worldwideExpress === true,
    then: (s) => s.required(`Please enter client id`),
  }),
  worldWideDirectPassword: Yup.string().when("worldwideExpress", {
    is: (worldwideExpress: any) => worldwideExpress === true,
    then: (s) => s.required(`Please enter client secret`),
  }),
  worldWideDirectURL: Yup.string().when("worldwideExpress", {
    is: (worldwideExpress: any) => worldwideExpress === true,
    then: (s) => s.required(`Please enter grant type`),
  }),
  banyanDirectReference: Yup.string().when("banyan", {
    is: (banyan: any) => banyan === true,
    then: (s) => s.required(`Please enter audience`),
  }),
  banyanDirectUser: Yup.string().when("banyan", {
    is: (banyan: any) => banyan === true,
    then: (s) => s.required(`Please enter client id`),
  }),
  banyanDirectPassword: Yup.string().when("banyan", {
    is: (banyan: any) => banyan === true,
    then: (s) => s.required(`Please enter client secret`),
  }),
  banyanDirectURL: Yup.string().when("banyan", {
    is: (banyan: any) => banyan === true,
    then: (s) => s.required(`Please enter grant type`),
  }),
  usedOrderReference2: Yup.string().when("isUsedOrderReference2", {
    is: true,
    then: (s) => s.required("Please enter Order Ref #2"),
    otherwise: (s) => s.notRequired(),
  }),

  //operationHrsFrom: Yup.string().required("Please enter from operation hours"),
  // operationHrsTo: Yup.string().test(
  //   "valid-end-time",
  //   "To operation hrs is not less than from operation hrs.",
  //   function (value, { parent }) {
  //     const fromOperationHrs = parent.operationHrsFrom;
  //     const toOperationHrs = value;
  //     if (
  //       new Date(`02-03-2023 ${fromOperationHrs}`) >
  //       new Date(`02-03-2023 ${toOperationHrs}`)
  //     ) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  // ),
});

export const addEditAgentFormSchema = Yup.object().shape({
  name: Yup.string().required(CONSTANTS.AGENT_NAME.validation.required),
  email: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .matches(EmailRegex, CONSTANTS.EMAIL.validation.valid),
  phoneNumber: Yup.string()
    .nullable() // allow null or empty
    .when("countryCode", {
      is: (countryCode: any) => countryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid).nullable(),
      otherwise: (s) =>
        s.min(10, CONSTANTS.PHONENUMBER.validation.valid).nullable(),
    }),
  agentType: Yup.string().required(CONSTANTS.AGENT_TYPE.validation.required),
});

export const addAgentRequestFormSchema = Yup.object().shape({
  name: Yup.string().required(CONSTANTS.AGENT_NAME.validation.required),
  email: Yup.string()
    .required(CONSTANTS.EMAIL.validation.required)
    .matches(EmailRegex, CONSTANTS.EMAIL.validation.valid),
  agentTypeId: Yup.string().required(CONSTANTS.AGENT_TYPE.validation.required),
  phoneNumber: Yup.string()
    .nullable()
    .when("countryCallingCode", {
      is: (countryCallingCode: any) => countryCallingCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid).nullable(),
      otherwise: (s) =>
        s.min(10, CONSTANTS.PHONENUMBER.validation.valid).nullable(),
    }),
});

export const addAgentHubFormSchema = Yup.object().shape({
  agentName: Yup.object().required("Please select agent name."),
  hubName: Yup.string().required(CONSTANTS.HUB_NAME.validation.required),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("countryCode", {
      is: (countryCode: any) => countryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
  operationEmailAddress: Yup.array()
    .min(1, CONSTANTS.EMAIL.validation.required)
    .test(
      "valid-contact-email",
      "Please enter valid operational email.",
      function (value, { parent }) {
        const emails = value;
        let emailStatus = true;
        if (Array.isArray(emails)) {
          emails.forEach((email) => {
            if (!EmailRegex.test(email)) {
              emailStatus = false;
            }
          });
        } else {
          emailStatus = false;
        }

        return emailStatus;
      }
    ),
  // activeDate: Yup.string()
  //   .test(
  //     "valid-active-date",
  //     "Active date should be greater than deactivate date.",
  //     function (value, { parent }) {
  //       const deactivate = parent.deactivateDate;
  //       const activeDate = value;
  //       if(deactivate === undefined && activeDate === undefined){
  //         return true;
  //       }
  //       return new Date(activeDate) <= new Date(deactivate);
  //     }
  //   ),
  deactivateDate: Yup.string().test(
    "valid-deactivate-date",
    "Deactivate date is not less than activate date.",
    function (value, { parent }) {
      const activeDate = parent.activeDate;
      const deactivate = value;
      if (!deactivate || !activeDate) {
        return true;
      }
      return new Date(activeDate) <= new Date(deactivate);
    }
  ),
  address: Yup.string().required(CONSTANTS.ADDRESS.validation.valid),
  //aptSuite: Yup.string().required("Please enter APT/Suite name"),
  zipCode: Yup.string()
    .required(CONSTANTS.ZIP_CODE.validation.valid)
    .min(5, CONSTANTS.ZIP_CODE.validation.valid)
    .max(9, CONSTANTS.ZIP_CODE.validation.valid),
  hubPhoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("hubCountryCode", {
      is: (hubCountryCode: any) => hubCountryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
  businessLocation: Yup.string().required("Please enter business location"),
  contactName: Yup.string().required(
    CONSTANTS.CONTACT_PERSON.validation.required
  ),
  contactEmail: Yup.array()
    .min(1, CONSTANTS.EMAIL.validation.required)
    .test(
      "valid-contact-email",
      "Please enter valid contact email.",
      function (value, { parent }) {
        const emails = value;
        let emailStatus = true;
        if (Array.isArray(emails)) {
          emails.forEach((email) => {
            if (!EmailRegex.test(email)) {
              emailStatus = false;
            }
          });
        } else {
          emailStatus = false;
        }

        return emailStatus;
      }
    ),
  masterHubId: Yup.string().when("isVirtualHub", {
    is: true,
    then: (schema) =>
      schema.required("Master Hub is required for a Virtual Hub"),
    otherwise: (schema) => schema.notRequired(),
  }),
  latitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-90, "Min latitude value should be -90")
    .max(90, "Max latitude value should be 90"),
  longitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-180, "Min longitude value should be -180")
    .max(180, "Max longitude value should be 180"),
  operationHrsFrom: Yup.string()
    .required("Please enter valid time(HH:MM)")
    .test(
      "valid-time-format",
      "Please enter valid time(HH:MM)",
      function (value) {
        if (!value) return false;
        // Check if it matches the 12-hour format with AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
        return timeRegex.test(value);
      }
    ),

  operationHrsTo: Yup.string()
    .required("Please enter valid time(HH:MM)")
    .test(
      "valid-time-format",
      "Please enter valid time(HH:MM)",
      function (value) {
        if (!value) return false;
        // Check if it matches the 12-hour format with AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
        return timeRegex.test(value);
      }
    ),
});

// export const orderStatusSchema = Yup.object().shape({
//   agent: Yup.object().required(CONSTANTS.AGENT_NAME.validation.required),
//   orderStatus: Yup.object().required(
//     CONSTANTS.ORDER_STATUS.validation.required
//   ),
//   statusLocation: Yup.string().required(
//     CONSTANTS.STATUS_LOCATION.validation.required
//   ),
//   zipCode: Yup.string()
//     .required(CONSTANTS.ZIP_CODE.validation.required)
//     .min(5, CONSTANTS.ZIP_CODE.validation.valid)
//     .max(9, CONSTANTS.ZIP_CODE.validation.valid),
//   statusTime: Yup.string().required(CONSTANTS.STATUS_TIME.validation.required),
//   statusDate: Yup.string().required(CONSTANTS.STATUS_DATE.validation.required),
//   // statusNote: Yup.string().required(CONSTANTS.STATUS_NOTE.validation.required),
// });
export const orderStatusSchema = Yup.object().shape({
  agent: Yup.object().required(CONSTANTS.AGENT_NAME.validation.required),
  orderStatus: Yup.object().required(
    CONSTANTS.ORDER_STATUS.validation.required
  ),
  statusLocation: Yup.string().optional(),
  zipCode: Yup.string()
    .optional()
    .min(5, CONSTANTS.ZIP_CODE.validation.valid)
    .max(9, CONSTANTS.ZIP_CODE.validation.valid),
  statusTime: Yup.string().optional(),
  statusDate: Yup.string().optional(),
  // statusNote: Yup.string().required(CONSTANTS.STATUS_NOTE.validation.required),
});

export const xceleratorApiSchema = Yup.object().shape({
  agentName: Yup.object({
    id: Yup.string().required(CONSTANTS.AGENT_NAME.validation.required),
  }),
  hubName: Yup.object({
    id: Yup.string().required(CONSTANTS.HUB_NAME.validation.required),
  }),
  apiUrl: Yup.string().required(CONSTANTS.API_URL.validation.required),
  apiAccountNo: Yup.string().required(
    CONSTANTS.API_ACCOUNT_NO.validation.required
  ),
  apiLogin: Yup.string().required(CONSTANTS.API_LOGIN.validation.required),
  apiPassword: Yup.string().required(
    CONSTANTS.API_PASSWORD.validation.required
  ),
  startDate: Yup.string().required(CONSTANTS.START_DATE.validation.required),
});

export const xceleratorApiServiceSchema = Yup.object().shape({
  serviceName: Yup.string().required(CONSTANTS.API_URL.validation.required),
  serviceCode: Yup.string().required(
    CONSTANTS.X_SERVICE_CODE.validation.required
  ),
  serviceId: Yup.string().required(CONSTANTS.X_SERVICE_ID.validation.required),
  serviceDuration: Yup.string().required(
    CONSTANTS.X_SERVICE_DURATION.validation.required
  ),
  details: Yup.string().required(
    CONSTANTS.X_SERVICE_DETAILS.validation.required
  ),
});

export const operationalAddressSchema = Yup.object().shape({
  address: Yup.string().required(CONSTANTS.ADDRESS.validation.valid),
  //aptSuite: Yup.string().required("Please enter APT/Suite name"),
  zipCode: Yup.string()
    .required(CONSTANTS.ZIP_CODE.validation.valid)
    .min(5, CONSTANTS.ZIP_CODE.validation.valid)
    .max(9, CONSTANTS.ZIP_CODE.validation.valid),
  phoneNumber: Yup.string()
    .required(CONSTANTS.PHONENUMBER.validation.required)
    .when("hubCountryCode", {
      is: (hubCountryCode: any) => hubCountryCode === "+1",
      then: (s) => s.min(16, CONSTANTS.PHONENUMBER.validation.valid),
      otherwise: (s) => s.min(10, CONSTANTS.PHONENUMBER.validation.valid),
    }),
  businessLocation: Yup.string().required("Please enter business location"),
  contactName: Yup.string().required(
    CONSTANTS.CONTACT_PERSON.validation.required
  ),
  contactEmail: Yup.array()
    .min(1, CONSTANTS.EMAIL.validation.required)
    .test(
      "valid-contact-email",
      "Please enter valid contact email.",
      function (value, { parent }) {
        const emails = value;
        let emailStatus = true;
        if (Array.isArray(emails)) {
          emails.forEach((email) => {
            if (!EmailRegex.test(email)) {
              emailStatus = false;
            }
          });
        } else {
          emailStatus = false;
        }

        return emailStatus;
      }
    ),
  latitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-90, "Min latitude value should be -90")
    .max(90, "Max latitude value should be 90"),
  longitude: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .min(-180, "Min longitude value should be -180")
    .max(180, "Max longitude value should be 180"),

  operationHrsFrom: Yup.string()
    .test(
      "valid-time-format",
      "Please enter valid time(HH:MM)",
      function (value) {
        if (!value) return true;
        // Check if it matches the 12-hour format with AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
        return timeRegex.test(value);
      }
    ),

  operationHrsTo: Yup.string()
    .test(
      "valid-time-format",
      "Please enter valid time(HH:MM)",
      function (value) {
        if (!value) return true;
        // Check if it matches the 12-hour format with AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
        return timeRegex.test(value);
      }
    ),
  //operationHrsFrom: Yup.string().required("Please enter from operation hours"),
  //operationHrsTo: Yup.string()
  //.required("Please enter to operation hours")
  // .test(
  //   "valid-end-time",
  //   "To operation hrs is not less or equal to the from operation hrs.",
  //   function (value, { parent }) {
  //     const fromOperationHrs = parent.operationHrsFrom;
  //     const toOperationHrs = value;
  //     if (
  //       new Date(`02-03-2023 ${fromOperationHrs}`) >=
  //       new Date(`02-03-2023 ${toOperationHrs}`)
  //     ) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  // ),
});

export const dispatchLoginDetails = Yup.object().shape({
  clientCode: Yup.string().required("Please enter client code"),
  //clientUrl: Yup.string().required("Please enter client url").url('Invalid URL format'),
  clientApi: Yup.string().required("Please enter client api"),
  //postUrl: Yup.string().required("Please enter post url").url('Invalid URL format'),
  //divLoc: Yup.string().required("Please enter divLoc"),
  //updateUrl: Yup.string().required("Please enter update url"),
  //inTransitStatus: Yup.string().required("Please enter inTransit status"),
  //startDate: Yup.string().required(CONSTANTS.START_DATE.validation.valid),
  customerName: Yup.string().required("Please enter account"),
  //dTSCode: Yup.string().required("Please enter dts code"),
  //billToId: Yup.string().required("Please enter bill to id"),
});

export const XceleratorLoginDetailsSchema = Yup.object().shape({
  apiUrl: Yup.string()
    .required("Please enter API url")
    .url("Invalid URL format"),
  apiAccountNo: Yup.string().required("Please enter API account number"),
  apiLogin: Yup.string().required("Please enter API login"),
  apiPassword: Yup.string().required("Please enter API password"),
  version: Yup.string().required("Please select API version"),
  //startDate: Yup.string().required(CONSTANTS.START_DATE.validation.valid),
});

// Decision D14 (Tech Fee): only Agent Type, Cost Type and Cost Value are
// mandatory. Cost Value must be above 0, and at most 100 for a percentage.
export const techFeeSchema = Yup.object().shape({
  agentType: Yup.string().required("Please select agent type"),
  costType: Yup.string().required("Please select cost type"),
  costValue: Yup.string()
    .required("Please enter cost value")
    .test(
      "cost-value-positive",
      "Cost value should be greater than 0",
      (value) => !value || Number(value) > 0
    )
    .test(
      "cost-value-percent",
      "Cost value should not be greater than 100",
      function (value) {
        return this.parent.costType !== "percent" || !value || Number(value) <= 100;
      }
    ),
});

export const OnwardLoginDetailsSchema = Yup.object().shape({
  // clientUrl: Yup.string().required("Please enter client URL").url("Invalid URL format"),
  // apiKey: Yup.string().required("Please enter API key"),
  carrierId: Yup.string().required("Please enter Carrier ID")
});
